module.exports = __webpack_public_path__ + "82255796d44ceb838ae87895737149b4.svg";